<template>
  <div class="footer">
      <div class="bottom">
        Copyright © 2024 - 2026 杭州醉蝶文化创意有限公司
      </div>
  </div>
</template>

<script>
export default{
  name: 'Footer',
  props:{
    hash:String
  },
  data() {
    return {
      isShow: true
    }
  },
  methods: {
  }
}
</script>

<style lang="less">
 .footer {background: #000;color:white;text-align:center;padding:20px 0px;}
</style>



// WEBPACK FOOTER //
// src/components/footer/Footer.vue